export const movies = [
  {
    id: "moonlit-promise",
    title: "春夜之约",
    originalTitle: "봄밤의 약속",
    year: 2024,
    country: "韩国",
    director: "金志勋",
    cast: ["李瑞妍", "朴成宰", "崔多恩"],
    genres: ["伦理", "剧情"],
    duration: 118,
    rating: 8.6,
    popularity: 96,
    featured: true,
    tagline: "一场迟到十年的重逢，把两个家庭推向无声的悬崖。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20romance%20drama%20poster%20still%2C%20young%20woman%20in%20cream%20trench%20coat%20standing%20inside%20a%20dim%20flower%20shop%20at%20night%2C%20rain%20streaking%20the%20window%20glass%2C%20warm%20amber%20lamps%20against%20deep%20navy%20shadows%2C%20restrained%20melancholic%20mood%2C%20editorial%20film%20photography%2C%20shallow%20depth%20of%20field%2C%20clean%20uncluttered%20dark%20background%2C%20portrait%20composition%2C%20no%20text%20no%20lettering&width=600&height=900&seq=kfilm-cover-01&orientation=portrait",
    tags: ["旧情重逢", "婚外情愫", "克制叙事", "首尔"],
    synopsis: [
      "首尔近郊的春天，离婚后独自经营花店的智媛，在旧同学的婚礼上遇见了大学时代的恋人贤宇。两人都已成家，却在一次次偶然的相遇里，重新辨认出彼此身上那些没有被时间带走的部分。",
      "影片把大部分篇幅留给了沉默：深夜的便利店、没说完的电话、停在门口的那把伞。导演金志勋用极其克制的镜头，让越界的念头停留在眼神与呼吸之间，把伦理的张力交给观众自己判断。",
      "春天结束的时候，两个人都要回到各自的生活。结局没有审判，只有一场平静的告别，和一句谁也没有说出口的「如果当初」。",
    ],
  },
  {
    id: "silent-vow",
    title: "无声的婚约",
    originalTitle: "침묵의 서약",
    year: 2023,
    country: "韩国",
    director: "尹素贞",
    cast: ["韩宥真", "姜泰旭", "白智媛"],
    genres: ["伦理", "剧情"],
    duration: 124,
    rating: 8.2,
    popularity: 88,
    featured: false,
    tagline: "婚礼前七天，她收到了未婚夫弟弟的告白。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20family%20drama%20poster%20still%2C%20elegant%20woman%20in%20a%20pale%20silk%20dress%20sitting%20alone%20in%20a%20formal%20dining%20room%2C%20long%20empty%20table%20with%20candles%2C%20cool%20moonlight%20through%20tall%20windows%2C%20deep%20charcoal%20green%20shadows%2C%20tense%20quiet%20atmosphere%2C%20refined%20editorial%20photography%2C%20soft%20film%20grain%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-02&orientation=portrait",
    tags: ["家庭伦理", "婚前秘密", "三角关系", "室内剧"],
    synopsis: [
      "婚礼前七天，准备嫁入豪门的瑞珍，被未婚夫的弟弟在雨夜里拦住。他说的那句话，把她原本安稳的人生规划撕开了一道口子。",
      "影片几乎全部发生在一天之内：一场家族晚宴、一条走廊、一间没有开灯的客房。每个人都在维持体面，每句客套话底下都藏着刀。",
      "当钟声敲响，瑞珍做出的选择并不壮烈，甚至称得上懦弱——但这正是导演想说的：在伦理的困局里，成年人往往只能选择更能承受的那种后悔。",
    ],
  },
  {
    id: "second-her-by-sea",
    title: "海边的第二个她",
    originalTitle: "바다의 두 번째 그녀",
    year: 2024,
    country: "韩国",
    director: "朴敏浩",
    cast: ["申河拉", "郑宇镇", "金多顺"],
    genres: ["伦理", "情色", "剧情"],
    duration: 111,
    rating: 8.0,
    popularity: 92,
    featured: true,
    tagline: "丈夫每年夏天都去同一片海，今年她决定跟过去看看。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20seaside%20drama%20poster%20still%2C%20woman%20in%20flowing%20white%20shirt%20standing%20on%20an%20empty%20windy%20beach%20at%20dusk%2C%20distant%20silhouette%20of%20a%20guesthouse%2C%20muted%20slate%20blue%20sea%20and%20warm%20sand%20tones%2C%20overcast%20soft%20light%2C%20lonely%20introspective%20mood%2C%20editorial%20film%20photography%2C%20gentle%20film%20grain%2C%20portrait%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-cover-03&orientation=portrait",
    tags: ["海边小镇", "婚姻危机", "秘密", "夏日"],
    synopsis: [
      "结婚八年，丈夫每年七月都会独自去东海岸的小镇住上四天。今年，妻子秀晶没有提前告知，悄悄跟了过去。",
      "她在那间老旧的民宿里，看见了一个与自己年纪相仿的女人，也看见了丈夫从未在她面前露出过的表情。三个人在同一张餐桌上吃了饭，谁都没有说破。",
      "导演用潮湿的海风与褪色的墙纸，包裹住一场没有爆发的婚姻危机。秀晶最终没有哭闹，她只是提前一天离开，把整个夏天留在了那片海里。",
    ],
  },
  {
    id: "room-thirty",
    title: "三十岁的房间",
    originalTitle: "서른의 방",
    year: 2022,
    country: "韩国",
    director: "李在勋",
    cast: ["文彩英", "赵显植", "吴娜拉"],
    genres: ["剧情", "伦理"],
    duration: 106,
    rating: 7.9,
    popularity: 74,
    featured: false,
    tagline: "合租的第三年，他们终于开始谈论租金以外的事。",
    cover: "https://readdy.ai/api/search-image?query=Intimate%20Korean%20indie%20drama%20poster%20still%2C%20young%20woman%20sitting%20on%20the%20floor%20of%20a%20small%20cramped%20Seoul%20apartment%20beside%20a%20battered%20sofa%2C%20single%20window%20with%20city%20lights%2C%20warm%20desk%20lamp%20glow%2C%20muted%20beige%20and%20deep%20brown%20tones%2C%20quiet%20lonely%20mood%2C%20natural%20film%20photography%2C%20soft%20shadows%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-04&orientation=portrait",
    tags: ["合租生活", "都市孤独", "三十岁", "独立电影"],
    synopsis: [
      "三十岁的允儿和二十七岁的实习生志浩合租一间老式公寓。两个人共享厨房、卫生间和一台老是坏掉的洗衣机，却从不共享彼此的生活。",
      "一次停电的夜里，他们坐在客厅的地板上喝着剩了半瓶的烧酒，第一次聊起各自失败的恋爱。距离在一瞬间被拉近，也在第二天清晨被重新拉远。",
      "这不是一部关于爱情的电影，而是关于都市里两个太累的人，如何在同一个屋檐下小心地互相取暖，又不至于烧到对方。",
    ],
  },
  {
    id: "rain-namsan",
    title: "雨落南山",
    originalTitle: "남산의 비",
    year: 2023,
    country: "韩国",
    director: "崔允熙",
    cast: ["高恩星", "李相民"],
    genres: ["伦理", "剧情"],
    duration: 115,
    rating: 8.3,
    popularity: 81,
    featured: false,
    tagline: "她在丈夫的书房里，找到了一封写给自己的旧信。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20melancholic%20Korean%20drama%20poster%20still%2C%20woman%20in%20a%20grey%20knit%20sweater%20holding%20an%20old%20folded%20letter%20by%20a%20rain-covered%20window%2C%20traditional%20Seoul%20rooftops%20blurred%20outside%2C%20cool%20blue%20rainlight%20mixed%20with%20a%20warm%20lamp%2C%20intimate%20quiet%20sorrow%2C%20editorial%20film%20photography%2C%20soft%20focus%20background%2C%20portrait%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-cover-05&orientation=portrait",
    tags: ["旧信", "婚姻真相", "回忆", "南山"],
    synopsis: [
      "丈夫去世后的第三个月，素英开始整理他留下的书房。在一本从未翻开过的诗集里，她发现了一封写于十年前的信，收信人是她自己。",
      "信里写的不是爱，而是一个男人在婚后第三年就已经动过的离开的念头。素英顺着信里的地址，找到了那个曾经差点带走丈夫的女人。",
      "两个女人在南山下的一家小茶馆坐了一个下午。没有争吵，也没有宽恕，只有两段被同一个男人改写的人生，在雨声里慢慢对齐。",
    ],
  },
  {
    id: "forgotten-summer",
    title: "被遗忘的夏天",
    originalTitle: "잊혀진 여름",
    year: 2021,
    country: "韩国",
    director: "金泰勇",
    cast: ["朴诗恩", "吴承勋", "李智安"],
    genres: ["剧情", "经典"],
    duration: 132,
    rating: 8.8,
    popularity: 70,
    featured: false,
    tagline: "二十年后重回故乡，她还是不敢推开那扇门。",
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20Korean%20period%20drama%20poster%20still%2C%20middle-aged%20woman%20standing%20in%20front%20of%20an%20old%20wooden%20house%20gate%20overgrown%20with%20vines%2C%20late%20afternoon%20golden%20haze%2C%20dust%20in%20the%20air%2C%20faded%20warm%20ochre%20and%20deep%20olive%20tones%2C%20bittersweet%20memory%20mood%2C%20cinematic%20film%20photography%2C%20soft%20grain%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-06&orientation=portrait",
    tags: ["故乡", "旧日恋情", "时间", "获奖作品"],
    synopsis: [
      "四十五岁的惠珍因为母亲的葬礼回到故乡，一座即将被拆迁的南方小城。二十年前，她从这里的某个夏夜逃走，再也没有回来过。",
      "葬礼上出现了很多熟悉的脸，包括当年那个说好要一起离开的少年。如今他已经是两个孩子的父亲，在镇上开着唯一一家五金店。",
      "影片用大量静止的长镜头记录这座小城最后的夏天。惠珍最终推开了那扇门，屋子里什么都没有，只有墙上褪色的一行字，和整整二十年的回声。",
    ],
  },
  {
    id: "daylight-confession",
    title: "白昼的告白",
    originalTitle: "백주의 고백",
    year: 2024,
    country: "韩国",
    director: "郑艺琳",
    cast: ["林秀雅", "河正民"],
    genres: ["伦理", "情色"],
    duration: 103,
    rating: 7.8,
    popularity: 89,
    featured: false,
    tagline: "她在正午的办公室里，说出了那句不该说的话。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20modern%20Korean%20office%20drama%20poster%20still%2C%20elegant%20woman%20in%20a%20tailored%20charcoal%20blazer%20leaning%20against%20a%20sunlit%20office%20window%2C%20blinds%20casting%20hard%20stripes%20of%20light%2C%20empty%20meeting%20room%20behind%20her%2C%20warm%20white%20daylight%20against%20cool%20grey%20interior%2C%20tense%20restrained%20desire%2C%20editorial%20photography%2C%20clean%20composition%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-07&orientation=portrait",
    tags: ["职场", "上下级", "告白", "白日"],
    synopsis: [
      "三十四岁的部门主管智秀，在一次加班后的正午，对下属说出了那句她准备了两年的话。对方没有回答，只是把百叶窗拉了下来。",
      "之后的日子里，两个人继续在会议室里讨论报表，在电梯里保持一米距离。整部电影没有一个拥抱，却处处都是越界的声音。",
      "当公司开始调查一段匿名举报时，智秀才发现，最先被怀疑的从来不是感情，而是权力。她必须决定，要不要为了保住职位而否认那天正午发生过的一切。",
    ],
  },
  {
    id: "twin-hotel",
    title: "双生花酒店",
    originalTitle: "쌍둥이 호텔",
    year: 2023,
    country: "韩国",
    director: "徐智厚",
    cast: ["李多海", "尹素拉", "金武烈"],
    genres: ["伦理", "剧情"],
    duration: 127,
    rating: 8.1,
    popularity: 79,
    featured: false,
    tagline: "同一间房里，住着两个长着同一张脸的女人。",
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20Korean%20mystery%20drama%20poster%20still%2C%20two%20identical%20women%20in%20matching%20dark%20dresses%20standing%20on%20opposite%20sides%20of%20a%20long%20hotel%20corridor%2C%20symmetrical%20wall%20lamps%2C%20deep%20burgundy%20carpet%2C%20dim%20golden%20light%2C%20uncanny%20quiet%20tension%2C%20cinematic%20symmetrical%20composition%2C%20editorial%20film%20photography%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-08&orientation=portrait",
    tags: ["双胞胎", "酒店", "身份", "悬疑感"],
    synopsis: [
      "经营着一家老式酒店的姐妹，在同一场事故后失去了部分记忆。姐姐记得自己是老板，妹妹记得自己才是。",
      "酒店里的客人开始察觉到异样：同一间房被重复预订，同一件礼服在两个人身上轮流出现，同一个男人在两周内收到了两份截然不同的告别。",
      "影片像一场慢速的魔术，观众不断在姐妹的叙述之间来回校正真相。直到最后一幕，镜头停在门牌号上——那间房从来只有一把钥匙。",
    ],
  },
  {
    id: "red-dress-white-wall",
    title: "红裙与白墙",
    originalTitle: "붉은 치마 흰 벽",
    year: 2022,
    country: "韩国",
    director: "宋慧兰",
    cast: ["车瑞京", "李东旭"],
    genres: ["情色", "伦理", "剧情"],
    duration: 98,
    rating: 7.6,
    popularity: 86,
    featured: false,
    tagline: "搬进新家的第一天，她就发现了墙上的那幅画。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20art-house%20poster%20still%2C%20woman%20in%20a%20deep%20crimson%20dress%20standing%20in%20a%20stark%20white%20empty%20gallery%20room%2C%20huge%20abstract%20canvas%20on%20the%20wall%2C%20strong%20graphic%20contrast%20of%20crimson%20and%20bone%20white%2C%20minimal%20composition%2C%20cool%20shadowless%20light%2C%20quiet%20provocative%20mood%2C%20editorial%20photography%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-09&orientation=portrait",
    tags: ["艺术圈", "新居", "欲望", "极简视觉"],
    synopsis: [
      "新婚夫妇搬进一栋由画廊改造的房子，客厅正中央挂着一幅没有署名的画。妻子每次经过都会停下几秒。",
      "丈夫请来画家修补墙面，才发现画里的人，和自己妻子有某种难以解释的相似。三个人在同一面墙前，开始了一场关于凝视与被凝视的角力。",
      "影片用大面积的白与一抹红构成全部视觉语言。结尾墙上只剩下一块干净的方形痕迹，像一场从未登记在册的展览。",
    ],
  },
  {
    id: "west-of-han",
    title: "汉江以西",
    originalTitle: "한강 서쪽",
    year: 2025,
    country: "韩国",
    director: "金志勋",
    cast: ["朴成宰", "韩素熙", "郑恩彩"],
    genres: ["伦理", "剧情"],
    duration: 121,
    rating: 8.5,
    popularity: 99,
    featured: true,
    tagline: "他把房子留给了前妻，把自己留在了江的另一边。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20urban%20melancholy%20poster%20still%2C%20man%20in%20a%20long%20dark%20coat%20standing%20on%20a%20river%20embankment%20at%20night%2C%20Han%20river%20bridge%20lights%20reflected%20in%20black%20water%2C%20blue%20hour%20sky%2C%20warm%20orange%20streetlamps%2C%20solitary%20atmospheric%20mood%2C%20cinematic%20photography%2C%20fine%20film%20grain%2C%20portrait%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-cover-10&orientation=portrait",
    tags: ["离婚", "中年", "城市", "2025新片"],
    synopsis: [
      "离婚后的第二年，道贤搬到了汉江以西的一间月租房。房子很小，窗户正对着前妻住的那栋公寓楼。",
      "他白天在物流中心开叉车，晚上给女儿打一通不超过五分钟的电话。直到某天，楼下搬来一个同样刚结束一段关系的女人。",
      "两个疲惫的中年人没有发生激烈的爱情，只是在便利店门口分一份关东煮，在江边并排走很长的路。影片说的不是重新开始，而是学会承认自己已经走到了哪里。",
    ],
  },
  {
    id: "gentle-cage",
    title: "温柔的囚笼",
    originalTitle: "온화한 새장",
    year: 2021,
    country: "韩国",
    director: "吴明洙",
    cast: ["申敏雅", "张赫镇", "李恩菲"],
    genres: ["剧情", "经典"],
    duration: 136,
    rating: 8.7,
    popularity: 66,
    featured: false,
    tagline: "她拥有一切，除了说「不」的权利。",
    cover: "https://readdy.ai/api/search-image?query=Prestigious%20Korean%20drama%20poster%20still%2C%20woman%20in%20a%20pale%20structured%20dress%20sitting%20very%20still%20in%20a%20vast%20luxury%20living%20room%2C%20tall%20curtains%20and%20cold%20marble%2C%20single%20shaft%20of%20pale%20light%2C%20desaturated%20grey%20and%20soft%20ivory%20palette%2C%20oppressive%20elegant%20stillness%2C%20cinematic%20wide%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-11&orientation=portrait",
    tags: ["豪门", "控制", "女性视角", "经典"],
    synopsis: [
      "婚后的第七年，素贤已经学会了在丈夫回家前把家里的每一个抱枕摆回原位。她的生活被安排得完美无缺，包括每天几点喝咖啡。",
      "一次偶然的家宴上，她遇见了丈夫的合作伙伴，一个会认真问她「你想吃什么」的陌生人。这句再普通不过的话，让她在洗手间里哭了很久。",
      "影片冷静地拆解了一段没有暴力的婚姻：没有人打她，也没有人骂她，她只是慢慢失去了说出自己想法的能力。最后一镜，她打开了那扇从未上锁的门。",
    ],
  },
  {
    id: "kyoto-rain-night",
    title: "京都的雨夜",
    originalTitle: "京都の雨夜",
    year: 2023,
    country: "日本",
    director: "高桥凉介",
    cast: ["绫濑千夏", "佐伯悠人"],
    genres: ["伦理", "剧情"],
    duration: 117,
    rating: 8.4,
    popularity: 84,
    featured: false,
    tagline: "一场雨，把两个陌生人困在了同一间町屋。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20romantic%20drama%20poster%20still%2C%20woman%20in%20a%20dark%20kimono%20standing%20under%20the%20eaves%20of%20a%20traditional%20Kyoto%20machiya%20at%20night%2C%20heavy%20rain%20and%20wet%20stone%20lanterns%2C%20warm%20paper%20lantern%20glow%20against%20deep%20indigo%20darkness%2C%20intimate%20hushed%20mood%2C%20cinematic%20photography%2C%20portrait%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-cover-12&orientation=portrait",
    tags: ["京都", "雨夜", "不伦", "和风"],
    synopsis: [
      "在京都经营一家旧书店的玲子，于一个暴雨的夜里收留了错过了末班车的男人。他说自己只是来这座城出差，明天一早就走。",
      "雨下了整整三天。两个人隔着一张矮桌吃饭、读书、听屋檐上的水声，把自己的婚姻、失败和遗憾一件件说了出来。",
      "雨停之后，男人留下了一把伞。玲子没有问他什么时候回来，只是在下一个雨夜，把那把伞放在了门口最显眼的位置。",
    ],
  },
  {
    id: "when-sakura-falls",
    title: "樱落之时",
    originalTitle: "桜の落ちる頃",
    year: 2024,
    country: "日本",
    director: "小林早苗",
    cast: ["白石凛", "大野和真", "藤森加奈"],
    genres: ["伦理", "情色", "剧情"],
    duration: 109,
    rating: 8.1,
    popularity: 91,
    featured: true,
    tagline: "樱花落尽之前，她把藏了十五年的秘密说了出来。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20spring%20drama%20poster%20still%2C%20woman%20in%20a%20soft%20pink%20knit%20cardigan%20standing%20beneath%20a%20blooming%20cherry%20tree%20at%20dusk%2C%20petals%20drifting%20through%20the%20air%2C%20blurred%20suburban%20street%20behind%2C%20warm%20rose%20and%20muted%20lavender%20grey%20tones%2C%20bittersweet%20tender%20mood%2C%20cinematic%20film%20photography%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-13&orientation=portrait",
    tags: ["樱花", "旧同学", "秘密", "春季"],
    synopsis: [
      "四月的镰仓，美绪在女儿的入学式上，遇见了十五年没见的高中同学。当年那场没有结果的告白，如今成了两个家庭之间的一根细线。",
      "她开始找各种理由出门：买花、取快递、去图书馆还书。每一次偶遇都精准得像排练过，只有她自己知道其中有多少刻意的成分。",
      "樱花落尽的那天，她把秘密说了出来。对方的沉默比拒绝更残忍，也更诚实。影片结尾，美绪一个人走在花瓣铺满的坡道上，脚步比来时轻了一点。",
    ],
  },
  {
    id: "kamakura-afternoon",
    title: "镰仓的午后",
    originalTitle: "鎌倉の午後",
    year: 2022,
    country: "日本",
    director: "中村透",
    cast: ["松井纱希", "藤原圭", "大岛千寻"],
    genres: ["剧情", "经典"],
    duration: 128,
    rating: 8.9,
    popularity: 72,
    featured: false,
    tagline: "一间咖啡馆，四个午后，两段没说完的人生。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20Japanese%20slice-of-life%20poster%20still%2C%20woman%20in%20a%20linen%20apron%20standing%20behind%20the%20counter%20of%20a%20tiny%20seaside%20cafe%2C%20sunlight%20falling%20across%20wooden%20tables%20and%20a%20single%20vase%20of%20flowers%2C%20open%20door%20showing%20a%20quiet%20Kamakura%20street%2C%20warm%20cream%20and%20soft%20amber%20palette%2C%20gentle%20calm%20mood%2C%20cinematic%20photography%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-14&orientation=portrait",
    tags: ["咖啡馆", "镰仓", "日常", "高分经典"],
    synopsis: [
      "镰仓海边一间只有六个座位的小咖啡馆，老板娘每天只做四样东西：咖啡、吐司、咖喱饭，和倾听。",
      "四个午后，四位客人：一个准备离婚的中年男人，一个不敢告诉母亲自己退学的女孩，一个每年都来同一天的老人，还有一个什么也不说只坐着的女人。",
      "影片没有戏剧性的转折，只有海风、杯碟碰撞的声音和一些终于被说出口的话。看完之后，你会想立刻找一家这样的小店坐一个下午。",
    ],
  },
  {
    id: "unsent-letter-tokyo",
    title: "东京·未寄出的信",
    originalTitle: "東京・出さなかった手紙",
    year: 2025,
    country: "日本",
    director: "山田绫",
    cast: ["宫原理沙", "石川凌"],
    genres: ["伦理", "剧情"],
    duration: 113,
    rating: 8.6,
    popularity: 97,
    featured: true,
    tagline: "她整理了三十七封信，每一封都写给同一个人。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20urban%20drama%20poster%20still%2C%20woman%20in%20a%20beige%20coat%20sitting%20at%20a%20small%20desk%20in%20a%20Tokyo%20apartment%20surrounded%20by%20stacks%20of%20old%20letters%2C%20late%20evening%20window%20with%20city%20glow%2C%20warm%20desk%20lamp%20against%20deep%20charcoal%20shadows%2C%20quiet%20confessional%20mood%2C%20cinematic%20photography%2C%20shallow%20depth%20of%20field%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-15&orientation=portrait",
    tags: ["书信", "东京", "错过", "2025新片"],
    synopsis: [
      "母亲去世后，香织在壁橱深处发现了一个铁盒，里面是三十七封未寄出的信，收信人全部是同一个人——她从未听说过的名字。",
      "她按着信封上的旧地址找到了东京下町的一间印刷厂。开门的是一个头发花白的男人，看见她时只说了一句：「你长得真像她。」",
      "三十七封信串起了母亲婚前的一段人生。香织一边读，一边重新认识那个她以为自己很了解的女人，也终于原谅了自己当年的那次逃离。",
    ],
  },
  {
    id: "snow-country-inn",
    title: "雪国旅馆",
    originalTitle: "雪国の宿",
    year: 2021,
    country: "日本",
    director: "川口修",
    cast: ["小野寺葵", "高梨诚", "森川绫"],
    genres: ["剧情", "情色", "伦理"],
    duration: 122,
    rating: 7.7,
    popularity: 63,
    featured: false,
    tagline: "大雪封山的那一晚，旅馆里只剩下三个人。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20winter%20drama%20poster%20still%2C%20woman%20in%20a%20thick%20cream%20sweater%20standing%20in%20the%20doorway%20of%20a%20traditional%20snowbound%20ryokan%2C%20deep%20snow%20falling%20outside%2C%20warm%20lantern%20light%20on%20dark%20wood%2C%20muted%20white%20and%20deep%20umber%20palette%2C%20solitary%20hushed%20mood%2C%20cinematic%20film%20photography%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-16&orientation=portrait",
    tags: ["雪国", "旅馆", "封闭空间", "冬季"],
    synopsis: [
      "年末的暴雪封住了通往山下的唯一道路，一家老式温泉旅馆里只剩下老板娘、一位长住的作家，和一个临时上山的年轻女服务员。",
      "三个人在同一个屋檐下度过了四天。热水、清酒、没有信号的电视，以及被大雪放大的每一句话。谁都没有明说，但每个人都在试探。",
      "雪停的那天早晨，作家收拾行李离开，只留下一本没有写完的书。老板娘翻到最后一页，发现里面写的是她。",
    ],
  },
  {
    id: "lights-of-seaside",
    title: "海街的灯火",
    originalTitle: "海街の灯",
    year: 2023,
    country: "日本",
    director: "森田千鹤",
    cast: ["长泽雪", "木村亮介", "小林真央"],
    genres: ["剧情", "经典"],
    duration: 134,
    rating: 8.8,
    popularity: 68,
    featured: false,
    tagline: "父亲留下的旧餐馆，和三个不愿意见面的女人。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20melancholic%20Japanese%20family%20drama%20poster%20still%2C%20three%20women%20of%20different%20ages%20standing%20together%20outside%20a%20small%20seaside%20restaurant%20at%20dusk%2C%20glowing%20windows%20and%20a%20red%20paper%20lantern%2C%20calm%20evening%20sea%20behind%20them%2C%20soft%20amber%20and%20deep%20teal%20palette%2C%20tender%20restrained%20mood%2C%20cinematic%20photography%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-17&orientation=portrait",
    tags: ["家庭", "海边", "和解", "女性群像"],
    synopsis: [
      "父亲去世后，留在海边小镇的旧餐馆成了一笔谁都不想接的遗产。三个同父异母的姐妹，因为这件事第一次坐在了同一张桌子前。",
      "大姐想把店卖掉，二姐想留下来继续做，最小的妹妹只想弄清楚父亲为什么从来没有提起过她们彼此。",
      "影片用一整个夏天的时间，让三个女人在厨房里吵完所有该吵的架。秋天开业那天，门口挂上了新的招牌，名字是三个人一起取的。",
    ],
  },
  {
    id: "summer-cicada",
    title: "夏日蝉鸣",
    originalTitle: "夏の蝉",
    year: 2022,
    country: "日本",
    director: "石井健",
    cast: ["青山遥", "佐藤健吾"],
    genres: ["伦理", "剧情"],
    duration: 104,
    rating: 7.8,
    popularity: 76,
    featured: false,
    tagline: "那个夏天，她第一次决定不再做个乖孩子。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20coming-of-age%20drama%20poster%20still%2C%20young%20woman%20in%20a%20white%20cotton%20dress%20standing%20in%20a%20sunlit%20overgrown%20garden%20in%20high%20summer%2C%20cicada%20shells%20on%20a%20tree%20trunk%2C%20harsh%20white%20sunlight%20and%20deep%20green%20shade%2C%20humid%20restless%20mood%2C%20cinematic%20film%20photography%2C%20portrait%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-cover-18&orientation=portrait",
    tags: ["成长", "夏天", "禁忌", "青春"],
    synopsis: [
      "十九岁的夏天，千夏在自家院子里第一次听见了那种让人烦躁的蝉鸣。她刚刚放弃了复读，也刚刚开始怀疑自己过去十九年做的每一个决定。",
      "邻居家的男人比她大十五岁，会在傍晚浇花的时候和她聊几句。那些对话轻得像没有发生过，却成了她整个夏天唯一期待的事。",
      "影片没有把这段关系浪漫化，也没有把它处理成丑闻。它只是诚实地记录一个女孩如何在被误解的注视里，第一次学会为自己做选择。",
    ],
  },
  {
    id: "hakone-mist",
    title: "箱根之雾",
    originalTitle: "箱根の霧",
    year: 2024,
    country: "日本",
    director: "高桥凉介",
    cast: ["篠原美月", "兼田隆", "小川沙耶"],
    genres: ["情色", "伦理", "剧情"],
    duration: 107,
    rating: 8.0,
    popularity: 87,
    featured: false,
    tagline: "雾气散开之前，谁都可以是另一个人。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20onsen%20drama%20poster%20still%2C%20woman%20in%20a%20white%20yukata%20seen%20from%20behind%20on%20a%20misty%20wooden%20terrace%2C%20thick%20fog%20hiding%20the%20mountain%20forest%2C%20stone%20lantern%20and%20steam%2C%20cool%20grey%20blue%20mist%20with%20a%20hint%20of%20warm%20lantern%20light%2C%20mysterious%20intimate%20mood%2C%20cinematic%20photography%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-19&orientation=portrait",
    tags: ["箱根", "温泉", "匿名", "雾"],
    synopsis: [
      "独自到箱根旅行的女人，在旅馆的雾气里被误认成了另一个人。她没有否认，跟着那个陌生的男人度过了一个不属于自己的夜晚。",
      "第二天清晨，雾散了。她在餐厅里看见对方和家人坐在一起，笑得体面而疲惫。两个人隔着一张长桌对视了一秒，然后各自低头。",
      "这场没有名字的相遇，成了她回到东京后唯一会反复想起的事。影片说的不是背叛，而是一个人有多渴望被当成另一个人来爱。",
    ],
  },
  {
    id: "late-night-bar",
    title: "深夜酒馆的她",
    originalTitle: "深夜の酒場",
    year: 2023,
    country: "日本",
    director: "小林早苗",
    cast: ["水野真央", "大西岳", "三浦千鹤"],
    genres: ["伦理", "剧情"],
    duration: 119,
    rating: 8.2,
    popularity: 83,
    featured: false,
    tagline: "凌晨一点，她只对陌生人说真话。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20night%20drama%20poster%20still%2C%20woman%20in%20a%20black%20dress%20sitting%20alone%20at%20a%20tiny%20counter%20bar%20late%20at%20night%2C%20rows%20of%20bottles%20backlit%20in%20amber%2C%20smoke%20and%20shallow%20warm%20light%2C%20empty%20stools%20beside%20her%2C%20deep%20brown%20and%20muted%20gold%20palette%2C%20intimate%20lonely%20mood%2C%20cinematic%20photography%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-20&orientation=portrait",
    tags: ["深夜", "酒馆", "陌生人", "都市"],
    synopsis: [
      "凌晨一点以后，东京某条小巷里的酒馆只剩下熟客。老板娘记得每个人的酒，也记得每个人不该被问起的事。",
      "这一晚来了一个第一次上门的男人。他点了一杯最便宜的酒，从十一点坐到了打烊，把一段失败的婚姻从头讲了一遍。",
      "影片几乎全部发生在吧台前，却一点也不闷。天亮时男人走了，老板娘把杯子洗干净，在账本上写下：今天也没有人问对方的名字。",
    ],
  },
  {
    id: "shirakawa-secret",
    title: "白川乡的秘密",
    originalTitle: "白川郷の秘密",
    year: 2021,
    country: "日本",
    director: "中村透",
    cast: ["田中絵里", "松本润一", "河合美咲"],
    genres: ["剧情", "经典"],
    duration: 141,
    rating: 8.6,
    popularity: 61,
    featured: false,
    tagline: "合掌造的老屋里，藏着一整个村子的沉默。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20rural%20mystery%20drama%20poster%20still%2C%20woman%20in%20a%20dark%20wool%20coat%20standing%20before%20a%20large%20thatched-roof%20gassho%20farmhouse%20in%20deep%20snow%2C%20smoke%20from%20the%20chimney%2C%20grey%20winter%20light%2C%20desaturated%20cold%20palette%20with%20a%20warm%20window%20glow%2C%20secretive%20somber%20mood%2C%20cinematic%20wide%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-21&orientation=portrait",
    tags: ["白川乡", "村落", "旧案", "经典"],
    synopsis: [
      "在东京做记者的菜穗回到白川乡的老家，为的是采访一场即将消失的传统仪式。但村子里的人似乎更希望她快点离开。",
      "她在祖母的遗物里找到一本旧名册，上面有十几个名字被划掉了。那些名字，对应着三十年前一个冬天里陆续离开村子的年轻人。",
      "随着雪一层层落下，村子的沉默也被一层层揭开。最后的答案并不惊人，它只是证明了：有些秘密之所以能保存这么久，是因为所有人都同意不去看。",
    ],
  },
  {
    id: "half-page-youth",
    title: "青春的半页",
    originalTitle: "青春の半ページ",
    year: 2024,
    country: "日本",
    director: "山田绫",
    cast: ["藤井纱良", "伊藤春人"],
    genres: ["伦理", "情色", "剧情"],
    duration: 101,
    rating: 7.5,
    popularity: 85,
    featured: false,
    tagline: "毕业前最后一页，他写下了她的名字。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20youth%20drama%20poster%20still%2C%20high%20school%20girl%20in%20a%20navy%20uniform%20standing%20in%20an%20empty%20classroom%20after%20school%2C%20late%20afternoon%20sunlight%20through%20half-open%20blinds%2C%20dust%20motes%20and%20wooden%20desks%2C%20warm%20honey%20tones%20with%20cool%20shadows%2C%20nostalgic%20restless%20mood%2C%20cinematic%20photography%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-22&orientation=portrait",
    tags: ["校园", "毕业", "师生", "初次心动"],
    synopsis: [
      "高中三年级的最后一个学期，成绩平平的咲良被班主任留下来补课。空荡荡的教室里，只有翻书的声音和窗外社团活动的余音。",
      "她渐渐发现，自己期待的不是补课，而是那一个小时里对方念她名字的方式。而对方也在某个瞬间，越过了一条本不该越过的线。",
      "影片拍得很轻，轻到几乎听不见心跳，却在每一个细节里埋下了危险。毕业典礼那天，咲良把那页写满名字的纸折好，放进了口袋，什么也没有说。",
    ],
  },
  {
    id: "kobe-old-port",
    title: "神户旧港",
    originalTitle: "神戸旧港",
    year: 2022,
    country: "日本",
    director: "川口修",
    cast: ["小林真由", "村上慧", "高桥沙织"],
    genres: ["剧情", "伦理"],
    duration: 116,
    rating: 8.0,
    popularity: 71,
    featured: false,
    tagline: "二十年前的船票，她还留着。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20harbor%20drama%20poster%20still%2C%20woman%20in%20a%20long%20navy%20coat%20holding%20an%20old%20paper%20ticket%20on%20a%20quiet%20Kobe%20pier%20at%20blue%20hour%2C%20cranes%20and%20mooring%20ropes%20blurred%20behind%2C%20wet%20asphalt%20reflections%2C%20cool%20steel%20blue%20and%20soft%20amber%20tones%2C%20nostalgic%20restrained%20sadness%2C%20cinematic%20photography%2C%20portrait%20framing%2C%20no%20text&width=600&height=900&seq=kfilm-cover-23&orientation=portrait",
    tags: ["神户", "港口", "旧情", "时间"],
    synopsis: [
      "神户旧港即将改造，最后一班渡轮开走后，码头就要拆了。在附近开洗衣店的雅子，翻出了一张二十年前的船票。",
      "那年她本来要跟一个人离开这座城市，结果在检票口前停住了脚。如今那人成了小有名气的摄影师，回到神户办一场关于港口的展览。",
      "两个人在展览现场重逢，像两艘错过泊位的船。影片没有让他们重新开始，只让他们把当年那句没说完的话，好好说完了。",
    ],
  },
  {
    id: "moon-of-nara",
    title: "奈良的月",
    originalTitle: "奈良の月",
    year: 2025,
    country: "日本",
    director: "森田千鹤",
    cast: ["和泉沙耶", "大塚悠真", "西村千夏"],
    genres: ["伦理", "经典", "剧情"],
    duration: 125,
    rating: 8.7,
    popularity: 94,
    featured: true,
    tagline: "她在古寺的月光下，第一次说出了自己的名字。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20art-house%20drama%20poster%20still%2C%20woman%20in%20a%20pale%20muted%20kimono%20standing%20in%20the%20courtyard%20of%20an%20old%20Nara%20temple%20at%20night%2C%20full%20moon%20above%20dark%20wooden%20roofs%2C%20stone%20path%20and%20ancient%20pine%2C%20silver%20moonlight%20with%20faint%20amber%20lanterns%2C%20still%20contemplative%20mood%2C%20cinematic%20photography%2C%20portrait%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-cover-24&orientation=portrait",
    tags: ["奈良", "古寺", "身份", "2025新片"],
    synopsis: [
      "在奈良一座古寺做修复工作的女人，已经在同一间工作室里待了十一年。她习惯了一个人吃饭、一个人加班，也习惯了别人叫她「老师」。",
      "一位来采访的年轻记者发现，她用的名字和户籍上的并不一样。那个被她留在二十年前的名字，属于另一个人，也属于另一段婚姻。",
      "影片在古寺的月光下展开一场关于身份的追问。当她终于说出自己的本名时，庭院里的鹿刚好走过。没有谁原谅谁，她只是终于把自己认了回来。",
    ],
  },
];

export const heroSlides = ["west-of-han", "moon-of-nara", "unsent-letter-tokyo", "second-her-by-sea", "when-sakura-falls"];

export const hotSearches = ["春夜之约", "汉江以西", "京都", "婚外", "2025新片", "经典高分"];